module.exports = __webpack_public_path__ + "static/media/APP_NightWatch_152x174_4.d8181dfc.png";